import React, { useMemo, useCallback } from 'react';
import { ReactGrid } from '@silevis/reactgrid';
import '@silevis/reactgrid/styles.css';

import {
  createTextCell,
  createNumberCell,
  createDateCell,
  createDropdownCell,
  createCheckboxCell,
} from 'components/spreadsheet/cellType';

const ExcelView = ({
  data = [],
  columns = [],
  onCellsChanged = () => {},
  className = 'excel-view-container position-relative',
}) => {
  const headerRow = useMemo(() => {
    return {
      rowId: 'header',
      cells: columns.map(col => ({
        type: 'header',
        text: col.header || '',
      })),
    };
  }, [columns]);

  const gridColumns = useMemo(() => {
    return columns.map(col => ({
      columnId: col.key,
      width: col.width || 180,
      resizable: true,
    }));
  }, [columns]);

  const rows = useMemo(() => {
    if (!data || data.length === 0) {
      return [headerRow]; // 데이터가 없을 경우 헤더만 표시
    }

    const dataRows = data.map(item => ({
      rowId: item.id,
      cells: columns.map(col => {
        const columnId = col.key;
        const value = item[columnId];
        const isDisabled = col.disabled || false;
        const isOpen = item[`${columnId}_isOpen`] || false;

        let cell;
        switch (col.type) {
          case 'checkbox':
            cell = createCheckboxCell(!!value, isDisabled);
            break;
          case 'date':
            cell = createDateCell(value, isDisabled);
            break;
          case 'number':
            cell = createNumberCell(value, isDisabled);
            break;
          case 'dropdown':
            cell = createDropdownCell(value, col.options, isDisabled, isOpen);
            break;
          default:
            cell = createTextCell(value, isDisabled);
        }

        return { ...cell, columnId };
      }),
    }));

    return [headerRow, ...dataRows];
  }, [data, columns, headerRow]);

  const handleChanges = useCallback(
    changes => {
      onCellsChanged(changes);
    },
    [onCellsChanged],
  );

  return (
    <div className={className}>
      <ReactGrid
        rows={rows}
        columns={gridColumns}
        onCellsChanged={handleChanges}
        enableRangeSelection
        enableFillHandle
        enableColumnSelection
        stickyTopRows={1}
      />
    </div>
  );
};

export default ExcelView;
